import { render, staticRenderFns } from "./PublishList.vue?vue&type=template&id=faa2632e&scoped=true&"
import script from "./PublishList.vue?vue&type=script&lang=js&"
export * from "./PublishList.vue?vue&type=script&lang=js&"
import style0 from "./PublishList.vue?vue&type=style&index=0&id=faa2632e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faa2632e",
  null
  
)

export default component.exports